// extracted by mini-css-extract-plugin
export default {"nft_modal":"styles_nft_modal__-zQof"};